import { render } from "./page-content.vue?vue&type=template&id=c3656cf8"
import script from "./page-content.vue?vue&type=script&lang=js"
export * from "./page-content.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__